import { filtered } from "./filters";

export const getSaveIsEnabled = (state) => {
  return state.saveParameterIsEnabled;
};

export const getParametersInfo = (state) => {
  return state.parameters.info;
};

export const getSectionIndex = (state) => {
  return state.parameters.section_index;
};

export const getVisualizationMode = (state) => {
  return state.visualizationMode;
};

export const accountInvestments = (state, getters, rootState) => {
  return getters.InvestmentsList;
};

export const InvestmentsList = (state) => {
  let investment = state.investment;

  if (state.adjustments.search != null) {
    investment = investment.filter((product) => {
      return product.strategy_name
        .toString()
        .toLowerCase()
        .includes(state.adjustments.search.toLowerCase());
    });
  }

  if (state.adjustments.filters.length > 0) {
    var _investment_aux = [];
    investment = investment.filter((product) => {
      if (
        state.adjustments.filters.some((x) =>
          product.strategy_symbol
            .toString()
            .toLowerCase()
            .includes(x.toLowerCase())
        )
      ) {
        _investment_aux.push(product);
      }

      if (
        state.adjustments.filters.some((x) =>
          product.status.toString().toLowerCase().includes(x.toLowerCase())
        )
      ) {
        _investment_aux.push(product);
      }

      if (
        state.adjustments.filters.some((x) =>
          product.type.toString().toLowerCase().includes(x.toLowerCase())
        )
      ) {
        _investment_aux.push(product);
      }

      if (
        state.adjustments.filters.some((x) =>
          product.strategy_name
            .toString()
            .toLowerCase()
            .includes(x.toLowerCase())
        )
      ) {
        _investment_aux.push(product);
      }

      if (
        state.adjustments.filters.some((x) =>
          product.position_status
            .toString()
            .toLowerCase()
            .includes(x.toLowerCase())
        )
      ) {
        _investment_aux.push(product);
      }
    });

    _investment_aux = _investment_aux.filter(function (elem, index, self) {
      return index === self.indexOf(elem);
    });

    return _investment_aux;
  }

  if (state.adjustments.order.asc) {
    let sorting = -1;

    investment = investment
      .slice(0)
      .sort((a, b) => (a.strategy_name < b.strategy_name ? sorting : -sorting));
  }

  if (state.adjustments.order.desc) {
    let sorting = 1;

    investment = investment
      .slice(0)
      .sort((a, b) => (a.strategy_name < b.strategy_name ? sorting : -sorting));
  }

  if (state.adjustments.order.max_profit) {
    let sorting = -1;

    investment = investment
      .slice(0)
      .sort((a, b) => (a.pnl < b.pnl ? sorting : -sorting));
  }

  if (state.adjustments.order.min_profit) {
    let sorting = -1;

    investment = investment
      .slice(0)
      .sort((a, b) => (a.pnl < b.pnl ? sorting : -sorting));
  }

  if (state.adjustments.order.position_asc) {
    let sorting = -1;

    investment = investment
      .slice(0)
      .sort((a, b) =>
        a.position_status < b.position_status ? sorting : -sorting
      );
  }

  if (state.adjustments.order.position_desc) {
    let sorting = 1;

    investment = investment
      .slice(0)
      .sort((a, b) =>
        a.position_status < b.position_status ? sorting : -sorting
      );
  }

  return investment;
};

export const getParameters = (state) => {
  return state.parameters;
};

export const getColors = (state) => {
  return state.color;
};

export const getSelectedParameters = (state) => {
  return state.selectedParameter;
};

export const getTopics = (state) => {
  let symbols = [];
  let investments = state.investment;

  investments.forEach((item) => {
    let symbol = item.strategy_symbol;
    if (typeof symbol === "string") {
      if (item?.position_status !== "Zerado") {
        symbols.push(symbol);
      }
    } else if (Array.isArray(symbol)) {
      item.sub_strategies.forEach((sub) => {
        if (sub.position_status !== "Zerado") {
          symbols.push(sub.strategy_symbol);
        }
      });
    }
  });

  let topics = symbols.map((symbol) => {
    if (symbol.startsWith("MD.")) return symbol;
    return `MD.${symbol}.L1`;
  });

  return Array(...new Set(topics));
};

export const getVisibleInvestments = (state) => {
  return state.investment.filter((item) => item.status !== "HIDDEN");
};

export const getFilters = (state) => {
  return state.filters;
};

export const getInvestments = (state) => {
  return state.investment;
};

export const getFilteredInvestments = filtered;

export const getFilterCount = (state) => {
  const filtersWithValueProp = state.filters.filter(
    (item) =>
      ["string", "range"].includes(item.type) &&
      item.value !== item.initialValue
  ).length;

  const filtersWithMultipleValues = state.filters
    .filter((item) => item.type === "tagbox" && item.active.length)
    .map((item) => item.active)
    .flat().length;

  return filtersWithValueProp + filtersWithMultipleValues;
};

export const getSymbolsFilterOptions = (state) => {
  let arr = [];
  state.investment
    .filter((item) => item.status !== "HIDDEN")
    .forEach((item) => {
      if (typeof item.strategy_symbol === "string") {
        arr.push(item.strategy_symbol);
      } else if (Array.isArray(item.strategy_symbol)) {
        item.strategy_symbol.forEach((symbol) => {
          arr.push(symbol);
        });
      }
    });

  let uniqueElements = Array(...new Set(arr));
  return uniqueElements.map((item) => {
    return {
      displayName: item,
      value: item,
    };
  });
  // return [
  //   ...new Set(
  //     state.investment
  //       .filter((item) => item.status !== "HIDDEN")
  //       .map((item) => item.strategy_symbol)
  //   ),
  // ].map((item) => {
  //   return {
  //     displayName: item,
  //     value: item,
  //   };
  // });
};

export const getDeveloperFilterOptions = (state) => {
  return [
    ...new Set(
      state.investment
        .filter((item) => item.status !== "HIDDEN")
        .map((item) => item.strategy_developer)
    ),
  ].map((item) => {
    return {
      displayName: item,
      value: item,
    };
  });
};

export const getTotalOpenPnl = (state) => {
  let { investment: investments } = state;

  const running_investments = investments.filter(
    (investment) => investment.status === "RUNNING"
  );

  let open_pnl = 0;
  running_investments.forEach((investment) => {
    if (investment.type === "PORTFOLIO") {
      investment.sub_strategies.forEach((sub) => {
        open_pnl += sub.open_pnl || 0;
      });
    } else if (
      investment.strategy_symbol === "ANY" &&
      investment?.curr_positions
    ) {
      investment.curr_positions.forEach((sub) => {
        open_pnl += sub.open_pnl || 0;
      });
    } else {
      open_pnl += investment.open_pnl || 0;
    }
  });

  return open_pnl;
};

export const getTotalClosedPnl = (state) => {
  let { investment: investments } = state;

  const running_investments = investments.filter(
    (investment) => investment.status === "RUNNING"
  );

  let closed_pnl = 0;
  running_investments.forEach((investment) => {
    if (investment.type === "PORTFOLIO") {
      investment.sub_strategies.forEach((sub) => {
        closed_pnl += (sub.position_profit || 0) + (sub.closed_pnl || 0);
      });
    } else if (
      investment.strategy_symbol === "ANY" &&
      investment?.curr_positions.length
    ) {
      investment.curr_positions.forEach((sub) => {
        closed_pnl += sub.position_profit || 0;
      });
    } else {
      closed_pnl += investment.position_profit;
    }
    if (investment?.closed_pnl) {
      closed_pnl += investment.closed_pnl;
    }
  });
  return closed_pnl;
};

export const getOpenPositionsNumber = (state) => {
  try {
    let { investment: investments } = state;
    let running_investments = investments.filter(
      (investment) => investment.status === "RUNNING"
    );
    let open_positions = 0;
    running_investments.forEach((investment) => {
      if (investment.type === "PORTFOLIO") {
        investment.sub_strategies.forEach((sub) => {
          if (sub.position_status != "Zerado") {
            open_positions++;
          }
        });
      } else if (
        investment.strategy_symbol === "ANY" &&
        investment?.curr_positions
      ) {
        investment.curr_positions.forEach((sub) => {
          if (sub.position_status != "Zerado") {
            open_positions++;
          }
        });
      } else if (investment.position_status != "Zerado") {
        open_positions++;
      }
    });
    return open_positions;
  } catch (err) {
    console.error(err);
  }
};

export const getRunningInvestmentsNumber = (state) => {
  let { investment: investments } = state;

  return investments.filter((investment) => investment.status == "RUNNING")
    .length;
};
